import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  BulkMultiselectActionsEnum,
  getBulkFormFieldName,
  ICustomField,
  ISelectListItem,
  requiredRuleStringField,
} from "@ryde/shared";

import { BulkActionFieldStackStyled } from "./bulk-action-field-stack.styled";
import { DropdownTemplate } from "./dropdown.template";
import { TextareaTemplate } from "./textarea.template";
import { useIsBulkControlSelected } from "./use-is-bulk-control-selected";

const bulkTextActionsSelectItems: ISelectListItem[] = [
  {
    value: BulkMultiselectActionsEnum.ADD,
    label: BulkMultiselectActionsEnum.ADD,
  },
  {
    value: BulkMultiselectActionsEnum.REPLACE,
    label: BulkMultiselectActionsEnum.REPLACE,
  },
];

const METADATA_REMARKS_FIELD_NAME = "metadata.remarks" as const;

export const BulkTextareaTemplate: FC<ICustomField> = props => {
  const { name } = props;
  const { t } = useTranslation();
  const isBulkControlSelected = useIsBulkControlSelected(name);

  // Only metadata.remarks (ride / feedback / …). Column "remarks" has no ADD/REPLACE action.
  const shouldRenderBulkAction = name === METADATA_REMARKS_FIELD_NAME;
  const bulkActionFieldName = useMemo(() => {
    return shouldRenderBulkAction ? getBulkFormFieldName(name) : null;
  }, [name, shouldRenderBulkAction]);

  if (!shouldRenderBulkAction || !bulkActionFieldName) {
    return <TextareaTemplate {...props} />;
  }

  return (
    <BulkActionFieldStackStyled>
      <DropdownTemplate
        name={bulkActionFieldName}
        labelTranslated={t("general.multiselectBulkAction")}
        formValidation={
          isBulkControlSelected ? requiredRuleStringField : undefined
        }
        formAttributes={{
          selectItems: bulkTextActionsSelectItems,
        }}
      />
      <TextareaTemplate {...props} />
    </BulkActionFieldStackStyled>
  );
};
